import ANALYTIC_EVENTS from "@/feature-analytics/analytic-events.mjs";
import { refs__PRIVATE as refs } from "@/feature-analytics/tracker.mjs";
import type { RocketEvent } from "@/game-rocket/models/events.mjs";

const AchievementSave_TA = "AchievementSave_TA";

export function onRocketLoad(data: RocketEvent) {
  const payload = getBase(data);
  // Append latest aggregate player data
  const achievements = data.save_game_manager.SaveData.SaveObjects.find(
    (i) => i.ClassName === AchievementSave_TA,
  );
  if (achievements?.Data) Object.assign(payload, achievements.Data);
  return refs.trackEvent(ANALYTIC_EVENTS.ROCKET_START, payload);
}

export function onExitRocketGame(data: RocketEvent) {
  const payload = getBase(data);
  // Append match player data
  const player = payload.EpicAccountId
    ? data.match_event.PRIs.find(
        (i) => i.UniqueId.EpicAccountId === payload.EpicAccountId,
      )
    : undefined;
  if (player) {
    for (const k in player) {
      if (typeof player[k] !== "number") continue;
      payload[k] = player[k];
    }
  }
  return refs.trackEvent(
    ANALYTIC_EVENTS.ROCKET_END,
    Object.assign(payload, {
      GameEndTime: Date.now(),
    }),
  );
}

export function onRocketRunning(isRunning) {
  return refs.trackEvent(ANALYTIC_EVENTS.ROCKET_RUNNING, { isRunning });
}

function getBase(data: RocketEvent): {
  PlayerName: string;
  EpicAccountId: string | undefined;
} {
  const { CachedEpicID, CleanPlayerID, PlayerID, PlayerName } =
    data.online_player;
  return {
    PlayerName,
    EpicAccountId:
      CachedEpicID ?? PlayerID.EpicAccountId ?? CleanPlayerID.EpicAccountId,
  };
}
